import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicFormControls, BasicTextArea, BaasicButton } from 'core/components';

function NikoPatientInsuranceQuestionModalTemplate({ nikoPatientInsuranceQuestionModalStore, t }) {
    const {
        form,
        resolveInsuranceQuestion,
        disabled
    } = nikoPatientInsuranceQuestionModalStore;

    const onKeyDown = (e) => {
        if (e.keyCode == 13) {
            e.preventDefault();
            form.onSubmit(e);
        }
    }

    return (
        <section>
            <div className="modal__header">
                <h3 className='modal__header__title'>Insurance Question</h3>
            </div>
            <div className="modal__body">
                <div className="form__group">
                    <BasicTextArea field={form.$('insuranceQuestion')} onKeyDown={onKeyDown} isFocus={true} disabled={disabled} />
                </div>
            </div>
            <div className='modal__footer'>
                <BaasicButton
                    className='btn btn--med btn--light'
                    label={t('EDIT_FORM_LAYOUT.RESOLVE')}
                    rotate
                    icon={
                        disabled
                            ? "u-icon u-icon--sml u-icon--sync u-rotate--login u-mar--right--tny"
                            : "u-icon u-icon--xmed u-icon--check"
                    }
                    onClick={() => resolveInsuranceQuestion()}
                    disabled={form.submitting || form.validating || disabled}
                />
                <BaasicFormControls
                    form={form}
                    className='btn btn--med btn--primary'
                    onSubmit={form.onSubmit}
                    disabled={form.submitting || form.validating || disabled}
                    label={t('EDIT_FORM_LAYOUT.SAVE')}
                />
            </div>
        </section>
    )
}

NikoPatientInsuranceQuestionModalTemplate.propTypes = {
    nikoPatientInsuranceQuestionModalStore: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(NikoPatientInsuranceQuestionModalTemplate);
